(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/payfooter-online.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/payfooter-online.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const userSession = svs.core.userSession;
svs.numbergames.game.views.PayFooterOnline = Marionette.View.extend({
  modelEvents: {
    'change:isSubscription': 'changedIsSubscription',
    'change:syndicateId change:price': 'updateBalance'
  },
  behaviors() {
    return [{
      behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
      channel: svs.numbergames.game.huxfluxRadio
    }, {
      behaviorClass: svs.tur.start_subscription.behaviors.HandleSubscription,
      start: true,
      change: true
    }, {
      behaviorClass: svs.numbergames.game.behaviors.Payfooter,
      shouldShowSum: () => true,
      payButtonTitle: () => {
        if (this.model.get('isSubscription')) {
          return this.model.get('subscriptionId') ? 'Ändra ({amount} kr / vecka)' : 'Starta ({amount} kr / vecka)';
        }
        return 'Betala {amount} kr';
      },
      payfooterBalanceText: () => {
        if (this.model.get('isSubscription')) {
          return '';
        }
        if (this.model.get('isSyndicate')) {
          return 'Vårt saldo: {amount} kr';
        }
        return 'Mitt saldo: {amount} kr';
      },
      payfooterSumText: () => {
        if (this.model.get('isSubscription')) {
          return 'Summa: {amount} kr / vecka';
        }
        return 'Summa: {amount} kr';
      },
      analyticsEvents: this.getOption('analyticsEvents')
    }];
  },
  initialize() {
    svs.numbergames.game.logger.debug('PayFooter initialize');
    if (svs.utils.paramHandler.get({
      key: 'pay'
    }).value) {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
      if (!userSession.hasRole(userSession.roles.PLAYER) || this.model.get('numRowsExceedMax')) {
        return;
      }
      if (this.model.get('isValid')) {
        this.triggerMethod('pay');
      } else {
        this.listenToOnce(this.model, 'change:isValid', () => {
          this.radio.request('notifyOnAllHuxfluxEnd', () => this.triggerMethod('pay'));
        });
      }
    }
  },
  onPayfooterCreated() {
    this.updateBalance();
  },
  async updateBalance() {
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      return;
    }
    try {
      const activeAcc = await svs.numbergames.accountSelector.getActiveAccount();
      this.triggerMethod('updatePayfooterBalance', parseInt(activeAcc.balance, 10));
    } catch (e) {
      svs.numbergames.game.logger.error(e);
    }
  },
  changedIsSubscription() {
    this.triggerMethod('updatePayButtonTitle');
    this.triggerMethod('updatePayfooterSum');
    this.triggerMethod('updatePayButtonState');
    this.updateBalance();
  },
  onPay() {
    var _this$model$get;
    svs.numbergames.game.logger.debug('User wants to pay');
    if (this.model.get('isSubscription')) {
      const prefix = this.model.has('subscriptionId') ? 'change' : 'start';
      const wagerObject = this.model.toObject();
      const subscriptionObject = svs.numbergames.game_model.utils.subscriptionFromWager(wagerObject);
      this.triggerMethod("".concat(prefix, "Subscription"), subscriptionObject);
      return;
    }
    const ticketsCollection = this.model.get('tickets');
    const _ticketsCollection$se = ticketsCollection.selectedTickets(),
      _ticketsCollection$se2 = _slicedToArray(_ticketsCollection$se, 1),
      ticketModel = _ticketsCollection$se2[0];
    const ticketData = ticketModel === null || ticketModel === void 0 ? void 0 : ticketModel.get('ticketData');
    const returnUrl = svs.utils.paramHandler.get({
      key: 'returnUrl'
    }).value;
    svs.numbergames.pay_numbergames.makePayment({
      onSuccessCb: () => this.model.removeFromLocalStorage(),
      onDoneCb: _ref => {
        let wagerIds = _ref.wagerIds,
          successfulTickets = _ref.successfulTickets,
          partialPaymentFailed = _ref.partialPaymentFailed;
        if (returnUrl) {
          svs.utils.url.navigate("".concat(svs.utils.url.makeInternal(decodeURIComponent(returnUrl), svs.core.urlMapping.get('myBetsHome'))));
        } else {
          let relatedUrl = "".concat(svs.core.data.baseUrl, "/relaterat?grassrootstoasterredirect");
          if (wagerIds && wagerIds.length) {
            relatedUrl += "&wagerIds=".concat(wagerIds.join(','));
          }
          if (successfulTickets && successfulTickets.length) {
            var _successfulTickets$;
            const ticketAmount = successfulTickets.length;
            relatedUrl += "&tickets=".concat(ticketAmount);
            relatedUrl += "&ticketId=".concat((_successfulTickets$ = successfulTickets[0]) === null || _successfulTickets$ === void 0 ? void 0 : _successfulTickets$.wagerId);
          }
          if (partialPaymentFailed) {
            relatedUrl += '&partialPaymentFailed';
          }
          setTimeout(() => svs.utils.url.navigate(relatedUrl), 500);
        }
      },
      wagerData: {
        product: this.model.get('productId'),
        price: this.model.get('price'),
        drawCount: this.model.get('drawCount'),
        wagers: svs.numbergames.game.pay.toApiWagers(this.model.toObject()),
        prolongedWagerId: (_this$model$get = this.model.get('prolongedBet')) === null || _this$model$get === void 0 ? void 0 : _this$model$get.wagerId
      },
      ticketData,
      showSuccessDialog: Boolean(returnUrl)
    });
  },
  onActivationSuccess() {
    this.model.removeFromLocalStorage();
  }
});

 })(window);